import RoleWiseLogs from "../Logs/RoleWiseLogs";

const UserLogs = ({ role }) => {
  return(
    <RoleWiseLogs role="user" title="User"></RoleWiseLogs>
  )
};

export default UserLogs;
